import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, ModalNotificationState } from '@/interfaces/store/modalNotification'
import { RootState } from '@/interfaces/store/root'
import ModalBottomNotificationOptions from '@/interfaces/modal-bottom-notification-options'

export const state: ModalNotificationState = {
  isModalActive: false,
  isModalTokenExpiredActive: false,
  modalOptions: undefined
}

export const getters: GetterTree<ModalNotificationState, RootState> & Getters = {}
export const actions: ActionTree<ModalNotificationState, RootState> & Actions = {
  onOpen({ commit }, options: ModalBottomNotificationOptions) {
    commit('updateModalOptions', options)
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    commit('updateModalActive', false)
  },
  onOpenTokenExpired({ commit }, options: ModalBottomNotificationOptions) {
    commit('updateModalOptions', options)
    commit('updateModalTokenExpiredActive', true)
  },
  onCloseTokenExpired({ commit }) {
    commit('updateModalTokenExpiredActive', false)
  },
}

export const mutations: MutationTree<ModalNotificationState> & Mutations = {
  updateModalActive(state: ModalNotificationState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalTokenExpiredActive(state: ModalNotificationState, isModalActive: boolean) {
    state.isModalTokenExpiredActive = isModalActive
  },
  updateModalOptions(state: ModalNotificationState, modalOptions: ModalBottomNotificationOptions) {
    state.modalOptions = modalOptions
  },
}

export const store: Module<ModalNotificationState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
